import { Section, GoldButton } from "@/components/site/Ui";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <Section className="max-w-xl">
      <div className="card-surface rounded-3xl p-8 sm:p-12 text-center">
        <XCircle className="mx-auto text-white/40" size={48} />
        <h1 className="mt-5 font-display text-2xl">Payment cancelled</h1>
        <p className="mt-3 text-white/60 text-sm">No worries — nothing was charged. Whenever you're ready, your plan is still here.</p>
        <GoldButton as="link" to="/content-plans" className="mt-7">Back to Content Plans</GoldButton>
      </div>
    </Section>
  );
}
